import React, { useState } from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'

import { ArrowIcon } from '@/components/ui/icons'
import { ContextLink } from '@/components/common/context-link'
import { TitleLink } from '@/types/title-link'

import { DropdownNavMenu } from './dropdown-nav-menu'
import { desktopViewQuery, mobileViewQuery } from './const'

export type NavMenuLinkProps = {
  item: TitleLink
  hasDropdown?: boolean
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 20px;
  height: 100%;

  @media ${mobileViewQuery} {
    height: auto;
  }
`

const ExtendedLink = styled(ContextLink)`
  text-decoration: none;
  color: white;
  font-weight: bold;
  border-bottom: none;
  font-family: 'PT Mono', monospace;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;

  @media ${desktopViewQuery} {
    &:hover::after {
      content: '';
      width: 100%;
      border-bottom: 5px solid ${({ theme }) => theme.palette.giphyAqua};
      position: absolute;
      bottom: 0;
    }
  }
`

const DropdownLink = styled.span`
  margin-right: 10px;
`

const DropdownContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.headerHeight}px;
  left: 0;
  width: 100vw;

  &.fade.enter {
    opacity: 0.01;
  }

  &.fade.enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }

  &.fade.exit {
    opacity: 1;
  }

  &.fade.exit-active {
    opacity: 0.01;
    transition: opacity 200ms ease-in;
  }
`

export const NavMenuLink = ({ item, hasDropdown }: NavMenuLinkProps) => {
  const [showDropdown, setShowDropdown] = useState(false)

  const onMouseEnter = () => {
    if (hasDropdown) {
      setShowDropdown(true)
    }
  }

  const onMouseLeave = () => {
    if (hasDropdown) {
      setShowDropdown(false)
    }
  }

  return (
    <Container onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <ExtendedLink to={item.link}>
        <>
          {hasDropdown && (
            <DropdownLink>
              <ArrowIcon rotate={0} />
            </DropdownLink>
          )}
          <span>{item.title}</span>
        </>
      </ExtendedLink>
      <CSSTransition in={showDropdown} className="fade" unmountOnExit timeout={200}>
        <DropdownContainer>
          <DropdownNavMenu />
        </DropdownContainer>
      </CSSTransition>
    </Container>
  )
}
